module.exports = __webpack_public_path__ + "static/media/mobileBlueoutline.9145aa8a.svg";